import styled, { css } from 'styled-components';
import { Primary } from './Button';
import { colors } from '../../theme/color';

export const RadioButton = styled(Primary).attrs({ role: 'radio' })<{
  selected: boolean;
}>(
  ({ selected, theme }) => css`
    border-radius: 0;
    background: ${selected ? theme.color?.button.selected : 'white'};
    color: ${selected ? 'white' : theme.color?.button.selected};
    border: 2px solid ${theme.color?.button.selected};
    border-right: 0;

    &:hover,
    &:focus-visible {
      background-color: ${({ theme }) => theme.isApp ? selected ? theme.color?.button.selected : 'white' : colors.green.darker(30)};
      border-color: ${({ theme }) => theme.isApp ? theme.color?.button.selected : colors.green.darker(30)};
      color: ${({ theme }) => theme.isApp ? selected ? 'white' : theme.color?.button.selected : colors.textWhite};
    }
  `
);

export const RadioButtonGroup = styled.div.attrs({ role: 'radiogroup' })<{ 'aria-label': string }>`
  display: flex;

  ${RadioButton}:first-child {
    border-radius: ${({ theme }) =>
      `${theme.sizes?.borderRadius.round} 0 0 ${theme.sizes?.borderRadius.round}`};
  }

  ${RadioButton}:last-child {
    border-radius: ${({ theme }) =>
      `0 ${theme.sizes?.borderRadius.round} ${theme.sizes?.borderRadius.round} 0`};
    border-right: 2px solid ${({ theme }) => theme.color?.button.selected};
  }
`;
